import GroupIcon from "@mui/icons-material/Group";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import SecurityIcon from "@mui/icons-material/Security";
import PersonIcon from "@mui/icons-material/Person";
import GpsFixed from "@mui/icons-material/GpsFixed";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import EventNoteIcon from "@mui/icons-material/EventNote";
import DescriptionIcon from "@mui/icons-material/Description";
import BlockIcon from "@mui/icons-material/Block";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import NoAccountsIcon from "@mui/icons-material/NoAccounts";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SpeedIcon from "@mui/icons-material/Speed";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import RepeatIcon from "@mui/icons-material/Repeat";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PaidIcon from "@mui/icons-material/Paid";
import StorefrontIcon from "@mui/icons-material/Storefront";
import HandshakeIcon from "@mui/icons-material/Handshake";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";

/**
 * Registro de íconos: nombre (string, tal como llega en `i_icon` desde
 * menu_items.icon) -> componente de @mui/icons-material.
 *
 * Es un objeto plano en vez de un switch para que agregar un ícono nuevo
 * sea "abrir/extensión" (agregar una línea) en vez de "modificación" de
 * lógica existente (principio abierto/cerrado). `resolveMenuIcon` es la
 * única función que debe importarse desde fuera de este archivo.
 *
 * Incluye:
 * 1) Los 8 nombres ya usados en menu_items.icon hoy (compatibilidad: si no
 *    se actualiza la base de datos, el menú se sigue viendo exactamente igual).
 * 2) Un set ampliado de íconos semánticamente distintos por módulo, para
 *    quien quiera diferenciar visualmente los módulos que hoy comparten
 *    ícono (ver icon-updates.sql adjunto).
 */
const ICON_REGISTRY = {
  // — Compatibilidad con los valores actuales de menu_items.icon —
  GroupIcon,
  PersonSearchIcon,
  ContentPasteSearchIcon,
  SecurityIcon,
  PersonIcon,
  GpsFixed,
  ManageAccountsIcon,
  DashboardCustomizeIcon,

  // — Set ampliado / diferenciado por módulo —
  RequestQuoteIcon,
  SupportAgentIcon,
  Inventory2Icon,
  EventNoteIcon,
  DescriptionIcon,
  BlockIcon,
  EventAvailableIcon,
  NoAccountsIcon,
  SummarizeIcon,
  SpeedIcon,
  PhoneInTalkIcon,
  RepeatIcon,
  VolunteerActivismIcon,
  AssignmentIndIcon,
  AccountBalanceWalletIcon,
  PlaylistAddCheckIcon,
  AccountBalanceIcon,
  ConfirmationNumberIcon,
  AddCircleIcon,
  AssessmentIcon,
  PaidIcon,
  StorefrontIcon,
  HandshakeIcon,
  FolderSpecialIcon,
};

const FALLBACK_ICON = DashboardCustomizeIcon;

export function resolveMenuIcon(iconName) {
  return ICON_REGISTRY[iconName] || FALLBACK_ICON;
}
